// 所有彈窗
'use client';

import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    popState,
    setShowComingModal,
    setShowLanguageModal,
    setShowUserModal,
    setShowNotifyModal,
    setShowLoginModal,
    setShowHintModal,
    setShowLoginFailModal,
} from '@/slices/popSlice';
import { userState } from '@/slices/userSlice';

import ComingSoonModal from './ComingSoonModal'; // 功能開放預告預告彈窗
import ToggleLanguagePop from './ToggleLanguagePop'; // 語言切換彈窗
import MobileBottomMenu from '../menu/MobileBottomMenu'; // 手機版置底彈窗
import UserModal from './UserModal'; // 使用者選單
import NotifyModal from './NotifyModal'; // 通知彈窗
import LoginModal from './login/LoginModal'; // 登入註冊彈窗
import HintModal from './HintModal'; // 提示小彈窗
import LoginFailModal from './login/LoginFailModal'; // 登入失敗彈窗

const ModalInner = ({ locale }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { user } = useSelector(userState);
    const {
        showComingModal,
        showLanguageModal,
        showUserModal,
        showNotifyModal,
        showLoginModal,
        showHintModal,
        hintText,
        showLoginFailModal,
    } = useSelector(popState);

    return (
        <>
            {/* 功能開放預告彈窗 */}
            {showComingModal && (
                <ComingSoonModal
                    setShowComingModal={setShowComingModal}
                    dispatch={dispatch}
                    showComingModal={showComingModal}
                />
            )}

            {/* 語言切換彈窗 */}
            {showLanguageModal && (
                <ToggleLanguagePop
                    dispatch={dispatch}
                    setShowLanguageModal={setShowLanguageModal}
                    locale={locale}
                />
            )}

            {/* 黑名單登入失敗彈窗 */}
            {showLoginFailModal && (
                <LoginFailModal
                    t={t}
                    dispatch={dispatch}
                    setShowLoginFailModal={setShowLoginFailModal}
                />
            )}

            {/* 手機置底選單 */}
            <MobileBottomMenu
                t={t}
                dispatch={dispatch}
                setShowUserModal={setShowUserModal}
                uid={user?.uid}
            />

            {/* 登入才顯示 ============================================= */}
            {user?.uid ? (
                <>
                    {/* user 資訊彈窗 */}
                    <UserModal
                        t={t}
                        dispatch={dispatch}
                        setShowUserModal={setShowUserModal}
                        showUserModal={showUserModal}
                        user={user}
                    />

                    {/* 通知彈窗 */}
                    <NotifyModal
                        t={t}
                        dispatch={dispatch}
                        showNotifyModal={showNotifyModal}
                        setShowNotifyModal={setShowNotifyModal}
                        locale={locale}
                    />

                    {/* 提示小彈窗 */}
                    <HintModal
                        t={t}
                        dispatch={dispatch}
                        showHintModal={showHintModal}
                        hintText={hintText}
                        setShowHintModal={setShowHintModal}
                    />
                </>
            ) : (
                <>
                    {/* 登入註冊彈窗 */}
                    {showLoginModal && (
                        <LoginModal
                            t={t}
                            dispatch={dispatch}
                            setShowLoginModal={setShowLoginModal}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default ModalInner;
